import { useState } from 'react';
import { ProjectsScreen } from './pages/Projects';
import { ProjectDetailScreen } from './pages/ProjectDetail';
import { LoginScreen } from './pages/Login';
import { CreateSiteScreen } from './pages/CreateSite';
import { useSession } from './contexts/SessionContext';

type View =
  | { kind: 'list' }
  | { kind: 'create' }
  | { kind: 'detail'; projectId: string };

export function App() {
  const { loading, user, logout } = useSession();
  const [view, setView] = useState<View>({ kind: 'list' });

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <LoginScreen />;
  }

  return (
    <div className="min-h-screen">
      <header className="bg-brand text-white border-b border-brand-dark">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <button
            type="button"
            className="text-xl font-semibold tracking-tight cursor-pointer hover:opacity-80"
            onClick={() => setView({ kind: 'list' })}
          >
            Sitekit Factory
          </button>
          <div className="flex items-center gap-4 text-sm">
            <span className="opacity-90">{user.displayName ?? user.email}</span>
            <button
              type="button"
              onClick={() => { void logout(); }}
              className="text-xs bg-white/10 hover:bg-white/20 px-3 py-1 rounded transition"
              title="Sign out"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-8">
        {view.kind === 'list' && (
          <ProjectsScreen
            onOpen={(id) => setView({ kind: 'detail', projectId: id })}
            onCreate={() => setView({ kind: 'create' })}
          />
        )}
        {view.kind === 'create' && (
          <CreateSiteScreen
            onCreated={(id) => setView({ kind: 'detail', projectId: id })}
            onCancel={() => setView({ kind: 'list' })}
          />
        )}
        {view.kind === 'detail' && (
          <ProjectDetailScreen
            projectId={view.projectId}
            onBack={() => setView({ kind: 'list' })}
          />
        )}
      </main>
    </div>
  );
}
